module.exports = __webpack_public_path__ + "img/image-circle-right-bottom.34f483c.jpg";